// 环境配置工具
export function getEnvConfig() {
  const appEnv = import.meta.env?.VITE_APP_ENV || 'development'

  // 环境映射
  const envMap = {
    development: 'dev',
    sit: 'sit',
    staging: 'stag',
    production: 'pro'
  }

  // 获取环境标识
  const envKey = envMap[appEnv] || 'dev'

  // 根据环境返回配置
  const configs = {
    dev: {
      env: 'dev',
      webfunnyDomain: '/',
      webfunnyAssetsDomain: 'http://wx.golaxy.cn:9010/',
      eventId: 'event_20260401_140749841_pro',
      webfunnyMonitorId: 'webfunny_20260402_142801_pro',
      projectVersion: '1.0.0',
      hasTrace: '0',
      envInitPoints: {
        heatBeat: 35, // 【全埋点】心跳，id随项目变化
        mouseStop: 36, // 【全埋点】停留，id随项目变化
        click: 37, // 【全埋点】点击，id随项目变化
        browsing: 39 // 【全埋点】浏览记录，id随项目变化
      }
    },
    sit: {
      env: 'sit',
      webfunnyDomain: '/',
      webfunnyAssetsDomain: 'http://wx.golaxy.cn:9010/',
      eventId: 'event_20260401_140749841_pro',
      webfunnyMonitorId: 'webfunny_20260402_142801_pro',
      projectVersion: '1.0.0',
      hasTrace: '0',
      envInitPoints: {
        heatBeat: 35, // 【全埋点】心跳，id随项目变化
        mouseStop: 36, // 【全埋点】停留，id随项目变化
        click: 37, // 【全埋点】点击，id随项目变化
        browsing: 39 // 【全埋点】浏览记录，id随项目变化
      }
    },

    pro: {
      env: 'pro',
      webfunnyDomain: '/',
      webfunnyAssetsDomain: 'http://wx.golaxy.cn:9010/',
      eventId: 'event_20260401_140749841_pro',
      webfunnyMonitorId: 'webfunny_20260402_142801_pro',
      projectVersion: '1.0.0',
      hasTrace: '0',
      envInitPoints: {
        heatBeat: 35, // 【全埋点】心跳，id随项目变化
        mouseStop: 36, // 【全埋点】停留，id随项目变化
        click: 37, // 【全埋点】点击，id随项目变化
        browsing: 39 // 【全埋点】浏览记录，id随项目变化
      }
    }
  }

  return configs[envKey] || configs.dev
}

// 导出当前环境配置
export const envConfig = getEnvConfig()
